import {
	Title,
	Text,
	Container,
	Button,
	Overlay,
  } from '@mantine/core';

import { useMsal } from '@azure/msal-react';
import { loginRequest } from "../authConfig";
import { clsx } from 'clsx';
import classes from './Login.module.css';

const Login = () => {
	const { instance } = useMsal();

	const handleLogin = () => {
		instance.loginRedirect(loginRequest).catch(e => {
			
		});
	}

	return <>
		{/* <Button onClick={handleLogin}>Login</Button> */}

		<div className={clsx(classes.hero, {
				[classes.hero_mbc]: import.meta.env.MODE === 'development' || import.meta.env.MODE === 'mbc-production' || import.meta.env.MODE === 'mbc-staging',
				[classes.hero_fhm]: import.meta.env.MODE === 'fhm-production' || import.meta.env.MODE === 'fhm-staging',
			})}>
			<Overlay
				gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 40%)"
				opacity={1}
				zIndex={0}
			/>
			<Container className={classes.container} size="md">
				<Title className={classes.title}>{import.meta.env.VITE_TITLE}</Title>
				<Text className={classes.description} size="xl" mt="xl">
					{import.meta.env.VITE_DESCRIPTION}
				</Text>

				<Button onClick={handleLogin} variant="filled" size="md" radius="md" className={classes.control}>
					Sign In
				</Button>
			</Container>
		</div>
	</>
}

export default Login